import { TEAMLIST_SEARCH, TEAMLIST_PAGE } from '../actions/teamlistactions';

const state = { search: '', page: 0 };

const getters = {
    page: state => state.page,
    search: state => state.search
};

const actions = {
    [TEAMLIST_SEARCH]: ({ commit }, search) => {
        commit(TEAMLIST_SEARCH, search);
    },
    [TEAMLIST_PAGE]: ({ commit }, page) => {
        commit(TEAMLIST_PAGE, page);
    }
};

const mutations = {
    [TEAMLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [TEAMLIST_PAGE]: (state, page) => {
        state.page = page;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};